/* @generated */
// prettier-ignore
if (Intl.NumberFormat && typeof Intl.NumberFormat.__addLocaleData === 'function') {
  Intl.NumberFormat.__addLocaleData({
  "data": {
    "currencies": {
      "ADP": {
        "displayName": {
          "one": "andorransk peseta",
          "other": "andorranska pesetas"
        },
        "narrow": "ADP",
        "symbol": "ADP"
      },
      "AED": {
        "displayName": {
          "other": "emiratisk dirham"
        },
        "narrow": "AED",
        "symbol": "AED"
      },
      "AFA": {
        "displayName": {
          "other": "afghani (1927–2002)"
        },
        "narrow": "AFA",
        "symbol": "AFA"
      },
      "AFN": {
        "displayName": {
          "one": "afghansk afghani",
          "other": "afghanska afghani"
        },
        "narrow": "؋",
        "symbol": "AFN"
      },
      "ALK": {
        "displayName": {
          "one": "albansk lek (1946–1965)",
          "other": "albanska lek (1946–1965)"
        },
        "narrow": "ALK",
        "symbol": "ALK"
      },
      "ALL": {
        "displayName": {
          "one": "albansk lek",
          "other": "albanska leke"
        },
        "narrow": "ALL",
        "symbol": "ALL"
      },
      "AMD": {
        "displayName": {
          "one": "armenisk dram",
          "other": "armeniska dram"
        },
        "narrow": "֏",
        "symbol": "AMD"
      },
      "ANG": {
        "displayName": {
          "other": "antillergulden"
        },
        "narrow": "ANG",
        "symbol": "ANG"
      },
      "AOA": {
        "displayName": {
          "one": "angolansk kwanza",
          "other": "angolanska kwanza"
        },
        "narrow": "Kz",
        "symbol": "AOA"
      },
      "AOK": {
        "displayName": {
          "one": "angolansk kwanza (1977–1990)",
          "other": "angolanska kwanza (1977–1990)"
        },
        "narrow": "AOK",
        "symbol": "AOK"
      },
      "AON": {
        "displayName": {
          "one": "angolansk kwanza (1990–2000)",
          "other": "angolanska nya kwanza (1990–2000)"
        },
        "narrow": "AON",
        "symbol": "AON"
      },
      "AOR": {
        "displayName": {
          "one": "angolansk kwanza reajustado (1995–1999)",
          "other": "angolanska kwanza reajustado (1995–1999)"
        },
        "narrow": "AOR",
        "symbol": "AOR"
      },
      "ARA": {
        "displayName": {
          "one": "argentinsk austral",
          "other": "argentinska australer"
        },
        "narrow": "ARA",
        "symbol": "ARA"
      },
      "ARL": {
        "displayName": {
          "one": "argentisk peso (1970–1983)",
          "other": "argentiska pesos (1970–1983)"
        },
        "narrow": "ARL",
        "symbol": "ARL"
      },
      "ARM": {
        "displayName": {
          "one": "argentisk peso (1881–1969)",
          "other": "argentiska pesos (1881–1969)"
        },
        "narrow": "ARM",
        "symbol": "ARM"
      },
      "ARP": {
        "displayName": {
          "one": "argentinsk peso (1983–1985)",
          "other": "argentinska pesos (1983–1985)"
        },
        "narrow": "ARP",
        "symbol": "ARP"
      },
      "ARS": {
        "displayName": {
          "one": "argentinsk peso",
          "other": "argentinska pesos"
        },
        "narrow": "$",
        "symbol": "ARS"
      },
      "ATS": {
        "displayName": {
          "one": "österrikisk schilling",
          "other": "österrikiska schilling"
        },
        "narrow": "ATS",
        "symbol": "ATS"
      },
      "AUD": {
        "displayName": {
          "one": "australisk dollar",
          "other": "australiska dollar"
        },
        "narrow": "$",
        "symbol": "AUD"
      },
      "AWG": {
        "displayName": {
          "one": "arubansk florin",
          "other": "arubanska floriner"
        },
        "narrow": "AWG",
        "symbol": "AWG"
      },
      "AZM": {
        "displayName": {
          "one": "azerbajdzjansk manat (1993–2006)",
          "other": "azerbajdzjanska manat (1993–2006)"
        },
        "narrow": "AZM",
        "symbol": "AZM"
      },
      "AZN": {
        "displayName": {
          "one": "azerbajdzjansk manat",
          "other": "azerbajdzjanska manat"
        },
        "narrow": "₼",
        "symbol": "AZN"
      },
      "BAD": {
        "displayName": {
          "one": "bosnisk-hercegovinsk dinar (1992–1994)",
          "other": "bosnisk-hercegovinska dinarer (1992–1994)"
        },
        "narrow": "BAD",
        "symbol": "BAD"
      },
      "BAM": {
        "displayName": {
          "one": "bosnisk-hercegovinsk mark (konvertibel)",
          "other": "bosnisk-hercegovinska mark (konvertibla)"
        },
        "narrow": "KM",
        "symbol": "BAM"
      },
      "BAN": {
        "displayName": {
          "one": "bosnisk-hercegovinsk dinar (1994–1998)",
          "other": "bosnisk-hercegovinska dinarer (1994–1998)"
        },
        "narrow": "BAN",
        "symbol": "BAN"
      },
      "BBD": {
        "displayName": {
          "one": "barbadisk dollar",
          "other": "barbadiska dollar"
        },
        "narrow": "$",
        "symbol": "Bds$"
      },
      "BDT": {
        "displayName": {
          "one": "bangladeshisk taka",
          "other": "bangladeshiska taka"
        },
        "narrow": "৳",
        "symbol": "BDT"
      },
      "BEC": {
        "displayName": {
          "one": "belgisk franc (konvertibel)",
          "other": "belgiska franc (konvertibla)"
        },
        "narrow": "BEC",
        "symbol": "BEC"
      },
      "BEF": {
        "displayName": {
          "one": "belgisk franc",
          "other": "belgiska franc"
        },
        "narrow": "BEF",
        "symbol": "BEF"
      },
      "BEL": {
        "displayName": {
          "one": "belgisk franc (finansiell)",
          "other": "belgiska franc (finansiella)"
        },
        "narrow": "BEL",
        "symbol": "BEL"
      },
      "BGL": {
        "displayName": {
          "one": "bulgarisk hård lev (1962–1999)",
          "other": "bulgariska hårda lev (1962–1999)"
        },
        "narrow": "BGL",
        "symbol": "BGL"
      },
      "BGM": {
        "displayName": {
          "one": "bulgarisk lev (1952–1962)",
          "other": "bulgariska lev (1952–1962)"
        },
        "narrow": "BGM",
        "symbol": "BGM"
      },
      "BGN": {
        "displayName": {
          "one": "bulgarisk lev",
          "other": "bulgariska leva"
        },
        "narrow": "BGN",
        "symbol": "BGN"
      },
      "BGO": {
        "displayName": {
          "other": "bulgarisk lev (1881–1952)"
        },
        "narrow": "BGO",
        "symbol": "BGO"
      },
      "BHD": {
        "displayName": {
          "one": "bahrainsk dinar",
          "other": "bahrainska dinarer"
        },
        "narrow": "BHD",
        "symbol": "BHD"
      },
      "BIF": {
        "displayName": {
          "one": "burundisk franc",
          "other": "burundiska franc"
        },
        "narrow": "BIF",
        "symbol": "BIF"
      },
      "BMD": {
        "displayName": {
          "one": "bermudisk dollar",
          "other": "bermudiska dollar"
        },
        "narrow": "$",
        "symbol": "BM$"
      },
      "BND": {
        "displayName": {
          "one": "bruneisk dollar",
          "other": "bruneiska dollar"
        },
        "narrow": "$",
        "symbol": "BND"
      },
      "BOB": {
        "displayName": {
          "one": "boliviansk boliviano",
          "other": "bolivianska bolivianos"
        },
        "narrow": "Bs",
        "symbol": "BOB"
      },
      "BOL": {
        "displayName": {
          "one": "boliviansk boliviano (1864–1963)",
          "other": "bolivianska bolivianos (1864–1963)"
        },
        "narrow": "BOL",
        "symbol": "BOL"
      },
      "BOP": {
        "displayName": {
          "one": "boliviansk peso",
          "other": "bolivianska pesos"
        },
        "narrow": "BOP",
        "symbol": "BOP"
      },
      "BOV": {
        "displayName": {
          "one": "boliviansk mvdol",
          "other": "bolivianska mvdol"
        },
        "narrow": "BOV",
        "symbol": "BOV"
      },
      "BRB": {
        "displayName": {
          "one": "brasiliansk cruzeiro (1967–1986)",
          "other": "brasilianska cruzeiro novo (1967–1986)"
        },
        "narrow": "BRB",
        "symbol": "BRB"
      },
      "BRC": {
        "displayName": {
          "one": "brasiliansk cruzado",
          "other": "brasilianska cruzado"
        },
        "narrow": "BRC",
        "symbol": "BRC"
      },
      "BRE": {
        "displayName": {
          "one": "brasiliansk cruzeiro (1990–1993)",
          "other": "brasilianska cruzeiro (1990–1993)"
        },
        "narrow": "BRE",
        "symbol": "BRE"
      },
      "BRL": {
        "displayName": {
          "one": "brasiliansk real",
          "other": "brasilianska real"
        },
        "narrow": "R$",
        "symbol": "BR$"
      },
      "BRN": {
        "displayName": {
          "one": "brasiliansk cruzado novo",
          "other": "brasilianska cruzado novo"
        },
        "narrow": "BRN",
        "symbol": "BRN"
      },
      "BRR": {
        "displayName": {
          "one": "brasiliansk cruzeiro",
          "other": "brasilianska cruzeiros"
        },
        "narrow": "BRR",
        "symbol": "BRR"
      },
      "BRZ": {
        "displayName": {
          "one": "brasiliansk cruzeiro (1942–1967)",
          "other": "brasilianska cruzeiros (1942–1967)"
        },
        "narrow": "BRZ",
        "symbol": "BRZ"
      },
      "BSD": {
        "displayName": {
          "one": "bahamansk dollar",
          "other": "bahamanska dollar"
        },
        "narrow": "$",
        "symbol": "BS$"
      },
      "BTN": {
        "displayName": {
          "one": "bhutanesisk ngultrum",
          "other": "bhutanesiska ngultrum"
        },
        "narrow": "BTN",
        "symbol": "BTN"
      },
      "BUK": {
        "displayName": {
          "one": "burmesisk kyat",
          "other": "burmesiska kyat"
        },
        "narrow": "BUK",
        "symbol": "BUK"
      },
      "BWP": {
        "displayName": {
          "one": "botswansk pula",
          "other": "botswanska pula"
        },
        "narrow": "P",
        "symbol": "BWP"
      },
      "BYB": {
        "displayName": {
          "one": "belarusisk ny rubel (1994–1999)",
          "other": "belarusiska nya rubel (1994–1999)"
        },
        "narrow": "BYB",
        "symbol": "BYB"
      },
      "BYN": {
        "displayName": {
          "one": "belarusisk rubel",
          "other": "belarusiska rubel"
        },
        "narrow": "р.",
        "symbol": "BYN"
      },
      "BYR": {
        "displayName": {
          "one": "belarusisk rubel (2000–2016)",
          "other": "belarusiska rubel (2000–2016)"
        },
        "narrow": "BYR",
        "symbol": "BYR"
      },
      "BZD": {
        "displayName": {
          "one": "belizisk dollar",
          "other": "beliziska dollar"
        },
        "narrow": "$",
        "symbol": "BZ$"
      },
      "CAD": {
        "displayName": {
          "one": "kanadensisk dollar",
          "other": "kanadensiska dollar"
        },
        "narrow": "$",
        "symbol": "CA$"
      },
      "CDF": {
        "displayName": {
          "one": "kongolesisk franc",
          "other": "kongolesiska franc"
        },
        "narrow": "CDF",
        "symbol": "CDF"
      },
      "CHE": {
        "displayName": {
          "one": "euro (WIR Bank)",
          "other": "euro (konvertibelt konto, WIR Bank, Schweiz)"
        },
        "narrow": "CHE",
        "symbol": "CHE"
      },
      "CHF": {
        "displayName": {
          "one": "schweizisk franc",
          "other": "schweiziska franc"
        },
        "narrow": "CHF",
        "symbol": "CHF"
      },
      "CHW": {
        "displayName": {
          "one": "franc (WIR Bank)",
          "other": "franc (konvertibelt konto, WIR Bank, Schweiz)"
        },
        "narrow": "CHW",
        "symbol": "CHW"
      },
      "CLE": {
        "displayName": {
          "one": "chilensk escudo (1960–1975)",
          "other": "chilenska escudos (1960–1975)"
        },
        "narrow": "CLE",
        "symbol": "CLE"
      },
      "CLF": {
        "displayName": {
          "one": "chilensk unidad de fomento",
          "other": "chilenska unidad de fomento"
        },
        "narrow": "CLF",
        "symbol": "CLF"
      },
      "CLP": {
        "displayName": {
          "one": "chilensk peso",
          "other": "chilenska pesos"
        },
        "narrow": "$",
        "symbol": "CLP"
      },
      "CNH": {
        "displayName": {
          "other": "kinesisk yuan (offshore)"
        },
        "narrow": "CNH",
        "symbol": "CNH"
      },
      "CNX": {
        "displayName": {
          "one": "kinesisk dollar",
          "other": "kinesiska dollar"
        },
        "narrow": "CNX",
        "symbol": "CNX"
      },
      "CNY": {
        "displayName": {
          "one": "kinesisk yuan",
          "other": "kinesiska yuan"
        },
        "narrow": "¥",
        "symbol": "CNY"
      },
      "COP": {
        "displayName": {
          "one": "colombiansk peso",
          "other": "colombianska pesos"
        },
        "narrow": "$",
        "symbol": "COP"
      },
      "COU": {
        "displayName": {
          "one": "colombiansk unidad de valor real",
          "other": "colombianska unidad de valor real"
        },
        "narrow": "COU",
        "symbol": "COU"
      },
      "CRC": {
        "displayName": {
          "one": "costarikansk colón",
          "other": "costarikanska colón"
        },
        "narrow": "₡",
        "symbol": "CRC"
      },
      "CSD": {
        "displayName": {
          "one": "serbisk dinar (2002–2006)",
          "other": "serbiska dinarer (2002–2006)"
        },
        "narrow": "CSD",
        "symbol": "CSD"
      },
      "CSK": {
        "displayName": {
          "one": "tjeckoslovakisk hård koruna",
          "other": "tjeckiska hårda koruna"
        },
        "narrow": "CSK",
        "symbol": "CSK"
      },
      "CUC": {
        "displayName": {
          "one": "kubansk peso (konvertibel)",
          "other": "kubanska pesos (konvertibla)"
        },
        "narrow": "$",
        "symbol": "CUC"
      },
      "CUP": {
        "displayName": {
          "one": "kubansk peso",
          "other": "kubanska pesos"
        },
        "narrow": "$",
        "symbol": "CUP"
      },
      "CVE": {
        "displayName": {
          "one": "kapverdisk escudo",
          "other": "kapverdiska escudos"
        },
        "narrow": "CVE",
        "symbol": "CVE"
      },
      "CYP": {
        "displayName": {
          "one": "cypriotiskt pund",
          "other": "cypriotiska pund"
        },
        "narrow": "CYP",
        "symbol": "CYP"
      },
      "CZK": {
        "displayName": {
          "one": "tjeckisk koruna",
          "other": "tjeckiska koruna"
        },
        "narrow": "Kč",
        "symbol": "CZK"
      },
      "DDM": {
        "displayName": {
          "one": "östtysk mark",
          "other": "östtyska mark"
        },
        "narrow": "DDM",
        "symbol": "DDM"
      },
      "DEM": {
        "displayName": {
          "one": "tysk mark",
          "other": "tyska mark"
        },
        "narrow": "DEM",
        "symbol": "DEM"
      },
      "DJF": {
        "displayName": {
          "one": "djiboutisk franc",
          "other": "djiboutiska franc"
        },
        "narrow": "DJF",
        "symbol": "DJF"
      },
      "DKK": {
        "displayName": {
          "one": "dansk krona",
          "other": "danska kronor"
        },
        "narrow": "kr",
        "symbol": "Dkr"
      },
      "DOP": {
        "displayName": {
          "one": "dominikansk peso",
          "other": "dominikanska pesos"
        },
        "narrow": "$",
        "symbol": "RD$"
      },
      "DZD": {
        "displayName": {
          "one": "algerisk dinar",
          "other": "algeriska dinarer"
        },
        "narrow": "DZD",
        "symbol": "DZD"
      },
      "ECS": {
        "displayName": {
          "one": "ecuadoriansk sucre",
          "other": "ecuadorianska sucre"
        },
        "narrow": "ECS",
        "symbol": "ECS"
      },
      "ECV": {
        "displayName": {
          "one": "ecuadoriansk unidad de valor constante",
          "other": "ecuadorianska unidad de valor constante"
        },
        "narrow": "ECV",
        "symbol": "ECV"
      },
      "EEK": {
        "displayName": {
          "one": "estnisk krona",
          "other": "estniska kronor"
        },
        "narrow": "Ekr",
        "symbol": "Ekr"
      },
      "EGP": {
        "displayName": {
          "one": "egyptiskt pund",
          "other": "egyptiska pund"
        },
        "narrow": "E£",
        "symbol": "EG£"
      },
      "ERN": {
        "displayName": {
          "one": "eritreansk nakfa",
          "other": "eritreanska nakfa"
        },
        "narrow": "ERN",
        "symbol": "ERN"
      },
      "ESA": {
        "displayName": {
          "one": "spansk peseta (konto)",
          "other": "spanska pesetas (konto)"
        },
        "narrow": "ESA",
        "symbol": "ESA"
      },
      "ESB": {
        "displayName": {
          "one": "spansk peseta (konvertibelt konto)",
          "other": "spanska pesetas (konvertibelt konto)"
        },
        "narrow": "ESB",
        "symbol": "ESB"
      },
      "ESP": {
        "displayName": {
          "one": "spansk peseta",
          "other": "spanska pesetas"
        },
        "narrow": "ESP",
        "symbol": "ESP"
      },
      "ETB": {
        "displayName": {
          "one": "etiopisk birr",
          "other": "etiopiska birr"
        },
        "narrow": "ETB",
        "symbol": "ETB"
      },
      "EUR": {
        "displayName": {
          "other": "euro"
        },
        "narrow": "€",
        "symbol": "€"
      },
      "FIM": {
        "displayName": {
          "one": "finsk mark",
          "other": "finska mark"
        },
        "narrow": "FIM",
        "symbol": "FIM"
      },
      "FJD": {
        "displayName": {
          "other": "Fijidollar"
        },
        "narrow": "$",
        "symbol": "FJD"
      },
      "FKP": {
        "displayName": {
          "other": "Falklandspund"
        },
        "narrow": "£",
        "symbol": "FKP"
      },
      "FRF": {
        "displayName": {
          "one": "fransk franc",
          "other": "franska franc"
        },
        "narrow": "FRF",
        "symbol": "FRF"
      },
      "GBP": {
        "displayName": {
          "one": "brittiskt pund",
          "other": "brittiska pund"
        },
        "narrow": "£",
        "symbol": "GBP"
      },
      "GEK": {
        "displayName": {
          "one": "georgisk kupon larit",
          "other": "georgiska kupon larit"
        },
        "narrow": "GEK",
        "symbol": "GEK"
      },
      "GEL": {
        "displayName": {
          "one": "georgisk lari",
          "other": "georgiska lari"
        },
        "narrow": "₾",
        "symbol": "GEL"
      },
      "GHC": {
        "displayName": {
          "one": "ghanansk cedi (1979–2007)",
          "other": "ghananska cedi (1979–2007)"
        },
        "narrow": "GHC",
        "symbol": "GHC"
      },
      "GHS": {
        "displayName": {
          "one": "ghanansk cedi",
          "other": "ghananska cedi"
        },
        "narrow": "GH₵",
        "symbol": "GHS"
      },
      "GIP": {
        "displayName": {
          "one": "gibraltiskt pund",
          "other": "gibraltiska pund"
        },
        "narrow": "£",
        "symbol": "GIP"
      },
      "GMD": {
        "displayName": {
          "one": "gambisk dalasi",
          "other": "gambiska dalasi"
        },
        "narrow": "GMD",
        "symbol": "GMD"
      },
      "GNF": {
        "displayName": {
          "one": "guineansk franc",
          "other": "guineanska franc"
        },
        "narrow": "FG",
        "symbol": "GNF"
      },
      "GNS": {
        "displayName": {
          "one": "guineansk syli",
          "other": "guineanska syli"
        },
        "narrow": "GNS",
        "symbol": "GNS"
      },
      "GQE": {
        "displayName": {
          "one": "ekvatorialguineansk ekwele",
          "other": "ekvatorialguineanska ekweler"
        },
        "narrow": "GQE",
        "symbol": "GQE"
      },
      "GRD": {
        "displayName": {
          "one": "grekisk drachma",
          "other": "grekiska drachmer"
        },
        "narrow": "GRD",
        "symbol": "GRD"
      },
      "GTQ": {
        "displayName": {
          "one": "guatemalansk quetzal",
          "other": "guatemalanska quetzal"
        },
        "narrow": "Q",
        "symbol": "GTQ"
      },
      "GWE": {
        "displayName": {
          "one": "Portugisiska Guinea-escudo",
          "other": "Portugisiska Guinea-escudos"
        },
        "narrow": "GWE",
        "symbol": "GWE"
      },
      "GWP": {
        "displayName": {
          "one": "Guinea-Bissau-peso",
          "other": "Guinea-Bissau-pesos"
        },
        "narrow": "GWP",
        "symbol": "GWP"
      },
      "GYD": {
        "displayName": {
          "other": "Guyanadollar"
        },
        "narrow": "$",
        "symbol": "GYD"
      },
      "HKD": {
        "displayName": {
          "other": "Hongkongdollar"
        },
        "narrow": "$",
        "symbol": "HKD"
      },
      "HNL": {
        "displayName": {
          "one": "honduransk lempira",
          "other": "honduranska lempira"
        },
        "narrow": "L",
        "symbol": "HNL"
      },
      "HRD": {
        "displayName": {
          "one": "kroatisk dinar",
          "other": "kroatiska dinarer"
        },
        "narrow": "HRD",
        "symbol": "HRD"
      },
      "HRK": {
        "displayName": {
          "one": "kroatisk kuna",
          "other": "kroatiska kunor"
        },
        "narrow": "kn",
        "symbol": "HRK"
      },
      "HTG": {
        "displayName": {
          "one": "haitisk gourde",
          "other": "haitiska gourder"
        },
        "narrow": "HTG",
        "symbol": "HTG"
      },
      "HUF": {
        "displayName": {
          "one": "ungersk forint",
          "other": "ungerska forinter"
        },
        "narrow": "Ft",
        "symbol": "HUF"
      },
      "IDR": {
        "displayName": {
          "one": "indonesisk rupie",
          "other": "indonesiska rupier"
        },
        "narrow": "Rp",
        "symbol": "IDR"
      },
      "IEP": {
        "displayName": {
          "one": "irländskt pund",
          "other": "irländska pund"
        },
        "narrow": "IE£",
        "symbol": "IE£"
      },
      "ILP": {
        "displayName": {
          "one": "israeliskt pund",
          "other": "israeliska pund"
        },
        "narrow": "ILP",
        "symbol": "ILP"
      },
      "ILR": {
        "displayName": {
          "one": "israelisk shekel (1980–1985)",
          "other": "israeliska shekel (1980–1985)"
        },
        "narrow": "ILR",
        "symbol": "ILR"
      },
      "ILS": {
        "displayName": {
          "one": "israelisk ny shekel",
          "other": "israeliska nya shekel"
        },
        "narrow": "₪",
        "symbol": "₪"
      },
      "INR": {
        "displayName": {
          "one": "indisk rupie",
          "other": "indiska rupier"
        },
        "narrow": "₹",
        "symbol": "INR"
      },
      "IQD": {
        "displayName": {
          "one": "irakisk dinar",
          "other": "irakiska dinarer"
        },
        "narrow": "IQD",
        "symbol": "IQD"
      },
      "IRR": {
        "displayName": {
          "one": "iransk rial",
          "other": "iranska rial"
        },
        "narrow": "IRR",
        "symbol": "IRR"
      },
      "ISJ": {
        "displayName": {
          "one": "isländsk gammal krona",
          "other": "isländska kronor (1874–1981)"
        },
        "narrow": "ISJ",
        "symbol": "ISJ"
      },
      "ISK": {
        "displayName": {
          "one": "isländsk krona",
          "other": "isländska kronor"
        },
        "narrow": "kr",
        "symbol": "Ikr"
      },
      "ITL": {
        "displayName": {
          "one": "italiensk lire",
          "other": "italienska lire"
        },
        "narrow": "ITL",
        "symbol": "ITL"
      },
      "JMD": {
        "displayName": {
          "one": "Jamaica-dollar",
          "other": "jamaicanska dollar"
        },
        "narrow": "$",
        "symbol": "JM$"
      },
      "JOD": {
        "displayName": {
          "one": "jordansk dinar",
          "other": "jordanska dinarer"
        },
        "narrow": "JOD",
        "symbol": "JOD"
      },
      "JPY": {
        "displayName": {
          "one": "japansk yen",
          "other": "japanska yen"
        },
        "narrow": "¥",
        "symbol": "JPY"
      },
      "KES": {
        "displayName": {
          "one": "kenyansk shilling",
          "other": "kenyanska shilling"
        },
        "narrow": "KES",
        "symbol": "KES"
      },
      "KGS": {
        "displayName": {
          "one": "kirgizisk som",
          "other": "kirgiziska somer"
        },
        "narrow": "⃀",
        "symbol": "KGS"
      },
      "KHR": {
        "displayName": {
          "one": "kambodjansk riel",
          "other": "kambodjanska riel"
        },
        "narrow": "៛",
        "symbol": "KHR"
      },
      "KMF": {
        "displayName": {
          "one": "komorisk franc",
          "other": "komoriska franc"
        },
        "narrow": "CF",
        "symbol": "KMF"
      },
      "KPW": {
        "displayName": {
          "one": "nordkoreansk won",
          "other": "nordkoreanska won"
        },
        "narrow": "₩",
        "symbol": "KPW"
      },
      "KRH": {
        "displayName": {
          "one": "sydkoreansk hwan (1953–1962)",
          "other": "sydkoreanska hwan (1953–1962)"
        },
        "narrow": "KRH",
        "symbol": "KRH"
      },
      "KRO": {
        "displayName": {
          "one": "sydkoreansk won (1945–1953)",
          "other": "sydkoreanska won (1945–1953)"
        },
        "narrow": "KRO",
        "symbol": "KRO"
      },
      "KRW": {
        "displayName": {
          "one": "sydkoreansk won",
          "other": "sydkoreanska won"
        },
        "narrow": "₩",
        "symbol": "KRW"
      },
      "KWD": {
        "displayName": {
          "one": "kuwaitisk dinar",
          "other": "kuwaitiska dinarer"
        },
        "narrow": "KWD",
        "symbol": "KWD"
      },
      "KYD": {
        "displayName": {
          "one": "caymansk dollar",
          "other": "caymanska dollar"
        },
        "narrow": "$",
        "symbol": "KYD"
      },
      "KZT": {
        "displayName": {
          "one": "kazakisk tenge",
          "other": "kazakiska tenge"
        },
        "narrow": "₸",
        "symbol": "KZT"
      },
      "LAK": {
        "displayName": {
          "one": "laotisk kip",
          "other": "laotiska kip"
        },
        "narrow": "₭",
        "symbol": "LAK"
      },
      "LBP": {
        "displayName": {
          "one": "libanesiskt pund",
          "other": "libanesiska pund"
        },
        "narrow": "L£",
        "symbol": "LBP"
      },
      "LKR": {
        "displayName": {
          "one": "srilankesisk rupie",
          "other": "srilankesiska rupier"
        },
        "narrow": "Rs",
        "symbol": "LKR"
      },
      "LRD": {
        "displayName": {
          "one": "liberiansk dollar",
          "other": "liberianska dollar"
        },
        "narrow": "$",
        "symbol": "LRD"
      },
      "LSL": {
        "displayName": {
          "one": "lesothisk loti",
          "other": "lesothiska lotier"
        },
        "narrow": "LSL",
        "symbol": "LSL"
      },
      "LTL": {
        "displayName": {
          "one": "litauisk litas",
          "other": "litauiska litai"
        },
        "narrow": "Lt",
        "symbol": "LTL"
      },
      "LTT": {
        "displayName": {
          "one": "litauisk talonas",
          "other": "litauiska talonas"
        },
        "narrow": "LTT",
        "symbol": "LTT"
      },
      "LUC": {
        "displayName": {
          "one": "luxemburgsk franc (konvertibel)",
          "other": "luxemburgska franc (konvertibla)"
        },
        "narrow": "LUC",
        "symbol": "LUC"
      },
      "LUF": {
        "displayName": {
          "one": "luxemburgsk franc",
          "other": "luxemburgska franc"
        },
        "narrow": "LUF",
        "symbol": "LUF"
      },
      "LUL": {
        "displayName": {
          "one": "luxemburgsk franc (finansiell)",
          "other": "luxemburgska franc (finansiella)"
        },
        "narrow": "LUL",
        "symbol": "LUL"
      },
      "LVL": {
        "displayName": {
          "one": "lettisk lats",
          "other": "lettiska lati"
        },
        "narrow": "Ls",
        "symbol": "LVL"
      },
      "LVR": {
        "displayName": {
          "one": "lettisk rubel",
          "other": "lettiska rubel"
        },
        "narrow": "LVR",
        "symbol": "LVR"
      },
      "LYD": {
        "displayName": {
          "one": "libysk dinar",
          "other": "libyska dinarer"
        },
        "narrow": "LYD",
        "symbol": "LYD"
      },
      "MAD": {
        "displayName": {
          "one": "marockansk dirham",
          "other": "marockanska dirhamer"
        },
        "narrow": "MAD",
        "symbol": "MAD"
      },
      "MAF": {
        "displayName": {
          "one": "marockansk franc",
          "other": "marockanska franc"
        },
        "narrow": "MAF",
        "symbol": "MAF"
      },
      "MCF": {
        "displayName": {
          "one": "monegaskisk franc (–2001)",
          "other": "monegaskiska franc (–2001)"
        },
        "narrow": "MCF",
        "symbol": "MCF"
      },
      "MDC": {
        "displayName": {
          "one": "moldavisk cupon (1992–1993)",
          "other": "moldaviska cupon (1992–1993)"
        },
        "narrow": "MDC",
        "symbol": "MDC"
      },
      "MDL": {
        "displayName": {
          "one": "moldavisk leu",
          "other": "moldaviska lei"
        },
        "narrow": "MDL",
        "symbol": "MDL"
      },
      "MGA": {
        "displayName": {
          "one": "madagaskisk ariary",
          "other": "madagaskiska ariary"
        },
        "narrow": "Ar",
        "symbol": "MGA"
      },
      "MGF": {
        "displayName": {
          "one": "madagaskisk franc",
          "other": "madagaskiska franc"
        },
        "narrow": "MGF",
        "symbol": "MGF"
      },
      "MKD": {
        "displayName": {
          "one": "makedonisk denar",
          "other": "makedoniska denarer"
        },
        "narrow": "MKD",
        "symbol": "MKD"
      },
      "MKN": {
        "displayName": {
          "one": "makedonisk denar (1992–1993)",
          "other": "makedoniska denarer (1992–1993)"
        },
        "narrow": "MKN",
        "symbol": "MKN"
      },
      "MLF": {
        "displayName": {
          "one": "malisk franc",
          "other": "maliska franc"
        },
        "narrow": "MLF",
        "symbol": "MLF"
      },
      "MMK": {
        "displayName": {
          "one": "myanmarisk kyat",
          "other": "myanmariska kyat"
        },
        "narrow": "K",
        "symbol": "MMK"
      },
      "MNT": {
        "displayName": {
          "one": "mongolisk tögrög",
          "other": "mongoliska tögrög"
        },
        "narrow": "₮",
        "symbol": "MNT"
      },
      "MOP": {
        "displayName": {
          "one": "makanesisk pataca",
          "other": "makanesiska pataca"
        },
        "narrow": "MOP",
        "symbol": "MOP"
      },
      "MRO": {
        "displayName": {
          "one": "mauretansk ouguiya (1973–2017)",
          "other": "mauretanska ouguiya (1973–2017)"
        },
        "narrow": "MRO",
        "symbol": "MRO"
      },
      "MRU": {
        "displayName": {
          "one": "mauretansk ouguiya",
          "other": "mauretanska ouguiya"
        },
        "narrow": "MRU",
        "symbol": "MRU"
      },
      "MTL": {
        "displayName": {
          "one": "maltesisk lire",
          "other": "maltesiska lire"
        },
        "narrow": "MTL",
        "symbol": "MTL"
      },
      "MTP": {
        "displayName": {
          "one": "maltesiskt pund",
          "other": "maltesiska pund"
        },
        "narrow": "MTP",
        "symbol": "MTP"
      },
      "MUR": {
        "displayName": {
          "one": "mauritisk rupie",
          "other": "mauritiska rupier"
        },
        "narrow": "Rs",
        "symbol": "MUR"
      },
      "MVP": {
        "displayName": {
          "one": "maldivisk rupie",
          "other": "maldiviska rupier"
        },
        "narrow": "MVP",
        "symbol": "MVP"
      },
      "MVR": {
        "displayName": {
          "one": "maldivisk rufiyaa",
          "other": "maldiviska rufiyer"
        },
        "narrow": "MVR",
        "symbol": "MVR"
      },
      "MWK": {
        "displayName": {
          "one": "malawisk kwacha",
          "other": "malawiska kwacha"
        },
        "narrow": "MWK",
        "symbol": "MWK"
      },
      "MXN": {
        "displayName": {
          "one": "mexikansk peso",
          "other": "mexikanska pesos"
        },
        "narrow": "$",
        "symbol": "MX$"
      },
      "MXP": {
        "displayName": {
          "one": "mexikansk silverpeso (1861–1992)",
          "other": "mexikanska silverpesos (1861–1992)"
        },
        "narrow": "MXP",
        "symbol": "MXP"
      },
      "MXV": {
        "displayName": {
          "one": "mexikansk unidad de inversion",
          "other": "mexikanska unidad de inversion"
        },
        "narrow": "MXV",
        "symbol": "MXV"
      },
      "MYR": {
        "displayName": {
          "one": "malaysisk ringgit",
          "other": "malaysiska ringgiter"
        },
        "narrow": "RM",
        "symbol": "MYR"
      },
      "MZE": {
        "displayName": {
          "one": "moçambikisk escudo (1914–1980)",
          "other": "moçambikiska escudos"
        },
        "narrow": "MZE",
        "symbol": "MZE"
      },
      "MZM": {
        "displayName": {
          "one": "moçambikisk metical (1980–2006)",
          "other": "gammla moçambikiska metical"
        },
        "narrow": "MZM",
        "symbol": "MZM"
      },
      "MZN": {
        "displayName": {
          "one": "moçambikisk metical",
          "other": "moçambikiska metical"
        },
        "narrow": "MZN",
        "symbol": "MZN"
      },
      "NAD": {
        "displayName": {
          "one": "namibisk dollar",
          "other": "namibiska dollar"
        },
        "narrow": "$",
        "symbol": "NAD"
      },
      "NGN": {
        "displayName": {
          "one": "nigeriansk naira",
          "other": "nigerianska naira"
        },
        "narrow": "₦",
        "symbol": "NGN"
      },
      "NIC": {
        "displayName": {
          "one": "nicaraguansk córdoba (1998–1991)",
          "other": "nicaraguanska córdobas (1988–1991)"
        },
        "narrow": "NIC",
        "symbol": "NIC"
      },
      "NIO": {
        "displayName": {
          "one": "nicaraguansk córdoba",
          "other": "nicaraguanska córdobas"
        },
        "narrow": "C$",
        "symbol": "NIO"
      },
      "NLG": {
        "displayName": {
          "one": "nederländsk gulden",
          "other": "nederländska gulden"
        },
        "narrow": "NLG",
        "symbol": "NLG"
      },
      "NOK": {
        "displayName": {
          "one": "norsk krona",
          "other": "norska kronor"
        },
        "narrow": "kr",
        "symbol": "Nkr"
      },
      "NPR": {
        "displayName": {
          "one": "nepalesisk rupie",
          "other": "nepalesiska rupier"
        },
        "narrow": "Rs",
        "symbol": "NPR"
      },
      "NZD": {
        "displayName": {
          "one": "nyzeeländsk dollar",
          "other": "nyzeeländska dollar"
        },
        "narrow": "$",
        "symbol": "NZD"
      },
      "OMR": {
        "displayName": {
          "one": "omansk rial",
          "other": "omanska rial"
        },
        "narrow": "OMR",
        "symbol": "OMR"
      },
      "PAB": {
        "displayName": {
          "one": "panamansk balboa",
          "other": "panamanska balboa"
        },
        "narrow": "PAB",
        "symbol": "PAB"
      },
      "PEI": {
        "displayName": {
          "one": "peruansk inti",
          "other": "peruanska intier"
        },
        "narrow": "PEI",
        "symbol": "PEI"
      },
      "PEN": {
        "displayName": {
          "one": "peruansk sol",
          "other": "peruanska sol"
        },
        "narrow": "PEN",
        "symbol": "PEN"
      },
      "PES": {
        "displayName": {
          "one": "peruansk sol (1863–1965)",
          "other": "peruanska sol (1863–1965)"
        },
        "narrow": "PES",
        "symbol": "PES"
      },
      "PGK": {
        "displayName": {
          "one": "papuansk kina",
          "other": "papuanska kinor"
        },
        "narrow": "PGK",
        "symbol": "PGK"
      },
      "PHP": {
        "displayName": {
          "one": "filippinsk peso",
          "other": "filippinska pesos"
        },
        "narrow": "₱",
        "symbol": "PHP"
      },
      "PKR": {
        "displayName": {
          "one": "pakistansk rupie",
          "other": "pakistanska rupier"
        },
        "narrow": "Rs",
        "symbol": "PKR"
      },
      "PLN": {
        "displayName": {
          "one": "polsk zloty",
          "other": "polska zloty"
        },
        "narrow": "zł",
        "symbol": "PLN"
      },
      "PLZ": {
        "displayName": {
          "one": "polsk zloty (1950–1995)",
          "other": "polska zloty (1950–1995)"
        },
        "narrow": "PLZ",
        "symbol": "PLZ"
      },
      "PTE": {
        "displayName": {
          "one": "portugisisk escudo",
          "other": "portugisiska escudos"
        },
        "narrow": "PTE",
        "symbol": "PTE"
      },
      "PYG": {
        "displayName": {
          "one": "paraguayansk guarani",
          "other": "paraguayska guarani"
        },
        "narrow": "₲",
        "symbol": "PYG"
      },
      "QAR": {
        "displayName": {
          "one": "qatarisk rial",
          "other": "qatariska rial"
        },
        "narrow": "QAR",
        "symbol": "QAR"
      },
      "RHD": {
        "displayName": {
          "one": "rhodesisk dollar",
          "other": "rhodesiska dollar"
        },
        "narrow": "RHD",
        "symbol": "RHD"
      },
      "ROL": {
        "displayName": {
          "one": "rumänsk leu (1952–2005)",
          "other": "rumänska leu (1952–2005)"
        },
        "narrow": "ROL",
        "symbol": "ROL"
      },
      "RON": {
        "displayName": {
          "one": "rumänsk leu",
          "other": "rumänska lei"
        },
        "narrow": "L",
        "symbol": "RON"
      },
      "RSD": {
        "displayName": {
          "one": "serbisk dinar",
          "other": "serbiska dinarer"
        },
        "narrow": "RSD",
        "symbol": "RSD"
      },
      "RUB": {
        "displayName": {
          "one": "rysk rubel",
          "other": "ryska rubel"
        },
        "narrow": "₽",
        "symbol": "RUB"
      },
      "RUR": {
        "displayName": {
          "one": "rysk rubel (1991–1998)",
          "other": "ryska rubel (1991–1998)"
        },
        "narrow": "RUR",
        "symbol": "RUR"
      },
      "RWF": {
        "displayName": {
          "one": "rwandisk franc",
          "other": "rwandiska franc"
        },
        "narrow": "RF",
        "symbol": "RWF"
      },
      "SAR": {
        "displayName": {
          "one": "saudisk riyal",
          "other": "saudiska riyal"
        },
        "narrow": "SAR",
        "symbol": "SAR"
      },
      "SBD": {
        "displayName": {
          "other": "Salomondollar"
        },
        "narrow": "$",
        "symbol": "SBD"
      },
      "SCR": {
        "displayName": {
          "one": "seychellisk rupie",
          "other": "seychelliska rupier"
        },
        "narrow": "SCR",
        "symbol": "SCR"
      },
      "SDD": {
        "displayName": {
          "one": "sudansk dinar (1992–2007)",
          "other": "sudanska dinarer (1992–2007)"
        },
        "narrow": "SDD",
        "symbol": "SDD"
      },
      "SDG": {
        "displayName": {
          "one": "sudanesiskt pund",
          "other": "sudanesiska pund"
        },
        "narrow": "SDG",
        "symbol": "SDG"
      },
      "SDP": {
        "displayName": {
          "one": "sudanskt pund (1916–1992)",
          "other": "sudanska pund (1916–1992)"
        },
        "narrow": "SDP",
        "symbol": "SDP"
      },
      "SEK": {
        "displayName": {
          "one": "svensk krona",
          "other": "svenska kronor"
        },
        "narrow": "kr",
        "symbol": "kr"
      },
      "SGD": {
        "displayName": {
          "one": "singaporiansk dollar",
          "other": "singaporianska dollar"
        },
        "narrow": "$",
        "symbol": "SGD"
      },
      "SHP": {
        "displayName": {
          "one": "sankthelenskt pund",
          "other": "sankthelenska pund"
        },
        "narrow": "£",
        "symbol": "SHP"
      },
      "SIT": {
        "displayName": {
          "one": "slovensk tolar",
          "other": "slovenska tolar"
        },
        "narrow": "SIT",
        "symbol": "SIT"
      },
      "SKK": {
        "displayName": {
          "one": "slovakisk krona",
          "other": "slovakiska korunor"
        },
        "narrow": "SKK",
        "symbol": "SKK"
      },
      "SLE": {
        "displayName": {
          "one": "sierraleonsk leone",
          "other": "sierraleonska leoner"
        },
        "narrow": "SLE",
        "symbol": "SLE"
      },
      "SLL": {
        "displayName": {
          "one": "sierraleonsk leone (1964—2022)",
          "other": "sierraleonska leoner (1964—2022)"
        },
        "narrow": "SLL",
        "symbol": "SLL"
      },
      "SOS": {
        "displayName": {
          "one": "somalisk shilling",
          "other": "somaliska shilling"
        },
        "narrow": "SOS",
        "symbol": "SOS"
      },
      "SRD": {
        "displayName": {
          "one": "surinamesisk dollar",
          "other": "surinamesiska dollar"
        },
        "narrow": "$",
        "symbol": "SRD"
      },
      "SRG": {
        "displayName": {
          "one": "surinamesisk gulden",
          "other": "surinamesiska gulden"
        },
        "narrow": "SRG",
        "symbol": "SRG"
      },
      "SSP": {
        "displayName": {
          "one": "sydsudanesiskt pund",
          "other": "sydsudanesiska pund"
        },
        "narrow": "£",
        "symbol": "SSP"
      },
      "STD": {
        "displayName": {
          "one": "saotomeansk dobra (1977–2017)",
          "other": "saotomeanska dobra (1977–2017)"
        },
        "narrow": "STD",
        "symbol": "STD"
      },
      "STN": {
        "displayName": {
          "one": "saotomeansk dobra",
          "other": "saotomeanska dobra"
        },
        "narrow": "Db",
        "symbol": "STN"
      },
      "SUR": {
        "displayName": {
          "one": "sovjetisk rubel",
          "other": "sovjetiska rubler"
        },
        "narrow": "SUR",
        "symbol": "SUR"
      },
      "SVC": {
        "displayName": {
          "one": "salvadoransk colón",
          "other": "salvadoranska colón"
        },
        "narrow": "SVC",
        "symbol": "SVC"
      },
      "SYP": {
        "displayName": {
          "one": "syriskt pund",
          "other": "syriska pund"
        },
        "narrow": "£",
        "symbol": "SYP"
      },
      "SZL": {
        "displayName": {
          "one": "swaziländsk lilangeni",
          "other": "swaziländska lilangeni"
        },
        "narrow": "SZL",
        "symbol": "SZL"
      },
      "THB": {
        "displayName": {
          "one": "thailändsk baht",
          "other": "thailändska baht"
        },
        "narrow": "฿",
        "symbol": "THB"
      },
      "TJR": {
        "displayName": {
          "one": "tadzjikisk rubel",
          "other": "tadzjikiska rubler"
        },
        "narrow": "TJR",
        "symbol": "TJR"
      },
      "TJS": {
        "displayName": {
          "one": "tadzjikisk somoni",
          "other": "tadzjikiska somoni"
        },
        "narrow": "TJS",
        "symbol": "TJS"
      },
      "TMM": {
        "displayName": {
          "one": "turkmenistansk manat (1993–2009)",
          "other": "turkmenistanska manat (1993–2009)"
        },
        "narrow": "TMM",
        "symbol": "TMM"
      },
      "TMT": {
        "displayName": {
          "one": "turkmenistansk manat",
          "other": "turkmenistanska manat"
        },
        "narrow": "TMT",
        "symbol": "TMT"
      },
      "TND": {
        "displayName": {
          "one": "tunisisk dinar",
          "other": "tunisiska dinarer"
        },
        "narrow": "TND",
        "symbol": "TND"
      },
      "TOP": {
        "displayName": {
          "one": "tongansk paʻanga",
          "other": "tonganska paʻanga"
        },
        "narrow": "T$",
        "symbol": "TOP"
      },
      "TPE": {
        "displayName": {
          "one": "östtimoresisk escudo",
          "other": "östtimoresiska escudos"
        },
        "narrow": "TPE",
        "symbol": "TPE"
      },
      "TRL": {
        "displayName": {
          "one": "turkisk lire (1922–2005)",
          "other": "turkiska lire (1922–2005)"
        },
        "narrow": "TRL",
        "symbol": "TRL"
      },
      "TRY": {
        "displayName": {
          "one": "turkisk lira",
          "other": "turkiska lira"
        },
        "narrow": "₺",
        "symbol": "TRY"
      },
      "TTD": {
        "displayName": {
          "other": "Trinidaddollar"
        },
        "narrow": "$",
        "symbol": "TTD"
      },
      "TWD": {
        "displayName": {
          "one": "taiwanesisk dollar",
          "other": "taiwanesiska dollar"
        },
        "narrow": "NT$",
        "symbol": "TWD"
      },
      "TZS": {
        "displayName": {
          "one": "tanzanisk shilling",
          "other": "tanzaniska shilling"
        },
        "narrow": "TZS",
        "symbol": "TZS"
      },
      "UAH": {
        "displayName": {
          "one": "ukrainsk hryvnia",
          "other": "ukrainska hryvnia"
        },
        "narrow": "₴",
        "symbol": "UAH"
      },
      "UAK": {
        "displayName": {
          "one": "ukrainsk karbovanetz (1992–1996)",
          "other": "ukrainska karbovanetz (1992–1996)"
        },
        "narrow": "UAK",
        "symbol": "UAK"
      },
      "UGS": {
        "displayName": {
          "one": "ugandisk shilling (1966–1987)",
          "other": "ugandiska shilling (1966–1987)"
        },
        "narrow": "UGS",
        "symbol": "UGS"
      },
      "UGX": {
        "displayName": {
          "one": "ugandisk shilling",
          "other": "ugandiska shilling"
        },
        "narrow": "UGX",
        "symbol": "UGX"
      },
      "USD": {
        "displayName": {
          "one": "amerikansk dollar",
          "other": "amerikanska dollar"
        },
        "narrow": "$",
        "symbol": "US$"
      },
      "USN": {
        "displayName": {
          "other": "US-dollar (nästa dag)"
        },
        "narrow": "USN",
        "symbol": "USN"
      },
      "USS": {
        "displayName": {
          "other": "US-dollar (samma dag)"
        },
        "narrow": "USS",
        "symbol": "USS"
      },
      "UYI": {
        "displayName": {
          "one": "uruguayansk peso en unidades indexadas",
          "other": "uruguayanska pesos en unidades indexadas"
        },
        "narrow": "UYI",
        "symbol": "UYI"
      },
      "UYP": {
        "displayName": {
          "one": "uruguayansk peso (1975–1993)",
          "other": "uruguayanska pesos (1975–1993)"
        },
        "narrow": "UYP",
        "symbol": "UYP"
      },
      "UYU": {
        "displayName": {
          "one": "uruguayansk peso",
          "other": "uruguayanska pesos"
        },
        "narrow": "$",
        "symbol": "UYU"
      },
      "UYW": {
        "displayName": {
          "other": "uruguayansk indexenhet för nominell lön"
        },
        "narrow": "UYW",
        "symbol": "UYW"
      },
      "UZS": {
        "displayName": {
          "one": "uzbekisk sum",
          "other": "uzbekiska sum"
        },
        "narrow": "UZS",
        "symbol": "UZS"
      },
      "VEB": {
        "displayName": {
          "one": "venezuelansk bolivar (1871–2008)",
          "other": "venezuelanska bolivar (1871–2008)"
        },
        "narrow": "VEB",
        "symbol": "VEB"
      },
      "VEF": {
        "displayName": {
          "one": "venezuelansk bolívar (2008–2018)",
          "other": "venezuelanska bolívar (2008–2018)"
        },
        "narrow": "Bs",
        "symbol": "VEF"
      },
      "VES": {
        "displayName": {
          "one": "venezuelansk bolívar",
          "other": "venezuelanska bolívar"
        },
        "narrow": "VES",
        "symbol": "VES"
      },
      "VND": {
        "displayName": {
          "one": "vietnamesisk dong",
          "other": "vietnamesiska dong"
        },
        "narrow": "₫",
        "symbol": "VND"
      },
      "VNN": {
        "displayName": {
          "one": "vietnamesisk dong (1978–1985)",
          "other": "vietnamesiska dong (1978–1985)"
        },
        "narrow": "VNN",
        "symbol": "VNN"
      },
      "VUV": {
        "displayName": {
          "one": "vanuatisk vatu",
          "other": "vanuatiska vatu"
        },
        "narrow": "VUV",
        "symbol": "VUV"
      },
      "WST": {
        "displayName": {
          "one": "västsamoansk tala",
          "other": "västsamoanska tala"
        },
        "narrow": "WST",
        "symbol": "WST"
      },
      "XAF": {
        "displayName": {
          "one": "centralafrikansk franc",
          "other": "centralafrikanska franc"
        },
        "narrow": "FCFA",
        "symbol": "FCFA"
      },
      "XAG": {
        "displayName": {
          "one": "uns silver",
          "other": "silveruns"
        },
        "narrow": "XAG",
        "symbol": "XAG"
      },
      "XAU": {
        "displayName": {
          "one": "uns guld",
          "other": "gulduns"
        },
        "narrow": "XAU",
        "symbol": "XAU"
      },
      "XBA": {
        "displayName": {
          "one": "europeisk kompositenhet",
          "other": "europeiska kompositenheter"
        },
        "narrow": "XBA",
        "symbol": "XBA"
      },
      "XBB": {
        "displayName": {
          "one": "europeisk monetär enhet",
          "other": "europeiska monetära enheter"
        },
        "narrow": "XBB",
        "symbol": "XBB"
      },
      "XBC": {
        "displayName": {
          "one": "europeisk kontoenhet (XBC)",
          "other": "europeiska kontoenheter (XBC)"
        },
        "narrow": "XBC",
        "symbol": "XBC"
      },
      "XBD": {
        "displayName": {
          "one": "europeisk kontoenhet (XBD)",
          "other": "europeiska kontoenheter (XBD)"
        },
        "narrow": "XBD",
        "symbol": "XBD"
      },
      "XCD": {
        "displayName": {
          "one": "östkaribisk dollar",
          "other": "östkaribiska dollar"
        },
        "narrow": "$",
        "symbol": "EC$"
      },
      "XCG": {
        "displayName": {
        },
        "narrow": "Cg.",
        "symbol": "Cg."
      },
      "XDR": {
        "displayName": {
          "one": "IMF särskild dragningsrätt",
          "other": "IMF särskilda dragningsrätter"
        },
        "narrow": "XDR",
        "symbol": "XDR"
      },
      "XEU": {
        "displayName": {
          "one": "europeisk valutaenhet",
          "other": "europeiska valutaenheter"
        },
        "narrow": "XEU",
        "symbol": "XEU"
      },
      "XFO": {
        "displayName": {
          "one": "fransk guldfranc",
          "other": "franska guldfranc"
        },
        "narrow": "XFO",
        "symbol": "XFO"
      },
      "XFU": {
        "displayName": {
          "other": "internationella järnvägsunionens franc"
        },
        "narrow": "XFU",
        "symbol": "XFU"
      },
      "XOF": {
        "displayName": {
          "one": "västafrikansk franc",
          "other": "västafrikanska franc"
        },
        "narrow": "F CFA",
        "symbol": "F CFA"
      },
      "XPD": {
        "displayName": {
          "one": "uns palladium",
          "other": "palladium"
        },
        "narrow": "XPD",
        "symbol": "XPD"
      },
      "XPF": {
        "displayName": {
          "other": "CFP-franc"
        },
        "narrow": "CFPF",
        "symbol": "CFPF"
      },
      "XPT": {
        "displayName": {
          "one": "uns platina",
          "other": "platina"
        },
        "narrow": "XPT",
        "symbol": "XPT"
      },
      "XRE": {
        "displayName": {
          "other": "RINET-fond"
        },
        "narrow": "XRE",
        "symbol": "XRE"
      },
      "XSU": {
        "displayName": {
          "one": "latinamerikansk sucre",
          "other": "latinamerikanska sucre"
        },
        "narrow": "XSU",
        "symbol": "XSU"
      },
      "XTS": {
        "displayName": {
          "one": "testvalutaenhet",
          "other": "testvalutaenheter"
        },
        "narrow": "XTS",
        "symbol": "XTS"
      },
      "XUA": {
        "displayName": {
          "one": "afrikansk kontoenhet",
          "other": "afrikanska kontoenheter"
        },
        "narrow": "XUA",
        "symbol": "XUA"
      },
      "XXX": {
        "displayName": {
          "one": "(okänd valutaenhet)",
          "other": "(okända valutaenheter)"
        },
        "narrow": "¤",
        "symbol": "¤"
      },
      "YDD": {
        "displayName": {
          "one": "jemenitisk dinar",
          "other": "jemenitiska dinarer"
        },
        "narrow": "YDD",
        "symbol": "YDD"
      },
      "YER": {
        "displayName": {
          "one": "jemenitisk rial",
          "other": "jemenitiska rial"
        },
        "narrow": "YER",
        "symbol": "YER"
      },
      "YUD": {
        "displayName": {
          "one": "jugoslavisk dinar (1966–1990)",
          "other": "jugoslaviska dinarer (1966–1990)"
        },
        "narrow": "YUD",
        "symbol": "YUD"
      },
      "YUM": {
        "displayName": {
          "one": "jugoslavisk dinar (1994–2002)",
          "other": "jugoslaviska dinarer (1994–2002)"
        },
        "narrow": "YUM",
        "symbol": "YUM"
      },
      "YUN": {
        "displayName": {
          "one": "jugoslavisk dinar (1990–1992)",
          "other": "jugoslaviska dinarer (1990–1992)"
        },
        "narrow": "YUN",
        "symbol": "YUN"
      },
      "YUR": {
        "displayName": {
          "one": "jugoslavisk dinar (1992–1993)",
          "other": "jugoslaviska dinarer (1992–1993)"
        },
        "narrow": "YUR",
        "symbol": "YUR"
      },
      "ZAL": {
        "displayName": {
          "one": "sydafrikansk rand (finansiell)",
          "other": "sydafrikanska rand (finansiella)"
        },
        "narrow": "ZAL",
        "symbol": "ZAL"
      },
      "ZAR": {
        "displayName": {
          "one": "sydafrikansk rand",
          "other": "sydafrikanska rand"
        },
        "narrow": "R",
        "symbol": "ZAR"
      },
      "ZMK": {
        "displayName": {
          "one": "zambisk kwacha (1968–2012)",
          "other": "zambiska kwacha (1968–2012)"
        },
        "narrow": "ZMK",
        "symbol": "ZMK"
      },
      "ZMW": {
        "displayName": {
          "one": "zambisk kwacha",
          "other": "zambiska kwacha"
        },
        "narrow": "ZK",
        "symbol": "ZMW"
      },
      "ZRN": {
        "displayName": {
          "one": "zaïrisk ny zaïre",
          "other": "zaïriska nya zaïre"
        },
        "narrow": "ZRN",
        "symbol": "ZRN"
      },
      "ZRZ": {
        "displayName": {
          "one": "zaïrisk zaïre",
          "other": "zaïriska zaïre"
        },
        "narrow": "ZRZ",
        "symbol": "ZRZ"
      },
      "ZWD": {
        "displayName": {
          "other": "Zimbabwe-dollar"
        },
        "narrow": "ZWD",
        "symbol": "ZWD"
      },
      "ZWL": {
        "displayName": {
          "other": "Zimbabwe-dollar (2009)"
        },
        "narrow": "ZWL",
        "symbol": "ZWL"
      },
      "ZWR": {
        "displayName": {
          "other": "Zimbabwe-dollar (2008)"
        },
        "narrow": "ZWR",
        "symbol": "ZWR"
      }
    },
    "nu": [
      "latn"
    ],
    "numbers": {
      "currency": {
        "latn": {
          "accounting": "#,##0.00 ¤",
          "currencySpacing": {
            "afterInsertBetween": " ",
            "beforeInsertBetween": " "
          },
          "short": {
            "1000": {
              "other": "0 tn ¤"
            },
            "10000": {
              "other": "00 tn ¤"
            },
            "100000": {
              "other": "000 tn ¤"
            },
            "1000000": {
              "other": "0 mn ¤"
            },
            "10000000": {
              "other": "00 mn ¤"
            },
            "100000000": {
              "other": "000 mn ¤"
            },
            "1000000000": {
              "other": "0 md ¤"
            },
            "10000000000": {
              "other": "00 md ¤"
            },
            "100000000000": {
              "other": "000 md ¤"
            },
            "1000000000000": {
              "other": "0 bn ¤"
            },
            "10000000000000": {
              "other": "00 bn ¤"
            },
            "100000000000000": {
              "other": "000 bn ¤"
            }
          },
          "standard": "#,##0.00 ¤",
          "unitPattern": "{0} {1}"
        }
      },
      "decimal": {
        "latn": {
          "long": {
            "1000": {
              "other": "0 tusen"
            },
            "10000": {
              "other": "00 tusen"
            },
            "100000": {
              "other": "000 tusen"
            },
            "1000000": {
              "one": "0 miljon",
              "other": "0 miljoner"
            },
            "10000000": {
              "one": "00 miljon",
              "other": "00 miljoner"
            },
            "100000000": {
              "other": "000 miljoner"
            },
            "1000000000": {
              "one": "0 miljard",
              "other": "0 miljarder"
            },
            "10000000000": {
              "other": "00 miljarder"
            },
            "100000000000": {
              "other": "000 miljarder"
            },
            "1000000000000": {
              "one": "0 biljon",
              "other": "0 biljoner"
            },
            "10000000000000": {
              "other": "00 biljoner"
            },
            "100000000000000": {
              "other": "000 biljoner"
            }
          },
          "short": {
            "1000": {
              "other": "0 tn"
            },
            "10000": {
              "other": "00 tn"
            },
            "100000": {
              "other": "000 tn"
            },
            "1000000": {
              "other": "0 mn"
            },
            "10000000": {
              "other": "00 mn"
            },
            "100000000": {
              "other": "000 mn"
            },
            "1000000000": {
              "other": "0 md"
            },
            "10000000000": {
              "other": "00 md"
            },
            "100000000000": {
              "other": "000 md"
            },
            "1000000000000": {
              "other": "0 bn"
            },
            "10000000000000": {
              "other": "00 bn"
            },
            "100000000000000": {
              "other": "000 bn"
            }
          },
          "standard": "#,##0.###"
        }
      },
      "nu": [
        "latn"
      ],
      "percent": {
        "latn": "#,##0 %"
      },
      "symbols": {
        "latn": {
          "approximatelySign": "~",
          "decimal": ",",
          "exponential": "×10^",
          "group": " ",
          "infinity": "∞",
          "list": ";",
          "minusSign": "−",
          "nan": "NaN",
          "perMille": "‰",
          "percentSign": "%",
          "plusSign": "+",
          "rangeSign": "‒",
          "superscriptingExponent": "×",
          "timeSeparator": ":",
          "timeSeparator-alt-variant": "."
        }
      }
    },
    "units": {
      "compound": {
        "per": {
          "long": "{0} per {1}",
          "narrow": "{0}/{1}",
          "short": "{0}/{1}"
        }
      },
      "simple": {
        "acre": {
          "long": {
            "one": "{0} engelskt tunnland",
            "other": "{0} engelska tunnland"
          },
          "narrow": {
            "other": "{0}ac"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ac"
          }
        },
        "bit": {
          "long": {
            "other": "{0} bit"
          },
          "narrow": {
            "other": "{0}b"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} b"
          }
        },
        "byte": {
          "long": {
            "other": "{0} byte"
          },
          "narrow": {
            "other": "{0}B"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} B"
          }
        },
        "celsius": {
          "long": {
            "one": "{0} grad Celsius",
            "other": "{0} grader Celsius"
          },
          "narrow": {
            "other": "{0}°C"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} °C"
          }
        },
        "centimeter": {
          "long": {
            "other": "{0} centimeter"
          },
          "narrow": {
            "other": "{0}cm"
          },
          "perUnit": {
            "long": "{0} per centimeter",
            "narrow": "{0}/cm",
            "short": "{0}/cm"
          },
          "short": {
            "other": "{0} cm"
          }
        },
        "day": {
          "long": {
            "other": "{0} dygn"
          },
          "narrow": {
            "other": "{0}d"
          },
          "perUnit": {
            "long": "{0} per dygn",
            "narrow": "{0}/d",
            "short": "{0}/d"
          },
          "short": {
            "other": "{0} d"
          }
        },
        "degree": {
          "long": {
            "one": "{0} grad",
            "other": "{0} grader"
          },
          "narrow": {
            "other": "{0}°"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°"
          }
        },
        "fahrenheit": {
          "long": {
            "one": "{0} grad Fahrenheit",
            "other": "{0} grader Fahrenheit"
          },
          "narrow": {
            "other": "{0}°F"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} °F"
          }
        },
        "fluid-ounce": {
          "long": {
            "one": "{0} flytande uns",
            "other": "{0} fluid ounces"
          },
          "narrow": {
            "other": "{0}fl oz"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} fl oz"
          }
        },
        "foot": {
          "long": {
            "other": "{0} fot"
          },
          "narrow": {
            "other": "{0}fot"
          },
          "perUnit": {
            "long": "{0} per fot",
            "narrow": "{0}/fot",
            "short": "{0}/fot"
          },
          "short": {
            "other": "{0} fot"
          }
        },
        "gallon": {
          "long": {
            "other": "{0} gallon"
          },
          "narrow": {
            "other": "{0}gal"
          },
          "perUnit": {
            "long": "{0} per gallon",
            "narrow": "{0}/gal US",
            "short": "{0}/gal US"
          },
          "short": {
            "other": "{0} gal"
          }
        },
        "gigabit": {
          "long": {
            "other": "{0} gigabit"
          },
          "narrow": {
            "other": "{0}Gb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Gb"
          }
        },
        "gigabyte": {
          "long": {
            "other": "{0} gigabyte"
          },
          "narrow": {
            "other": "{0}GB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} GB"
          }
        },
        "gram": {
          "long": {
            "other": "{0} gram"
          },
          "narrow": {
            "other": "{0}g"
          },
          "perUnit": {
            "long": "{0} per gram",
            "narrow": "{0}/g",
            "short": "{0}/g"
          },
          "short": {
            "other": "{0} g"
          }
        },
        "hectare": {
          "long": {
            "other": "{0} hektar"
          },
          "narrow": {
            "other": "{0}ha"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ha"
          }
        },
        "hour": {
          "long": {
            "one": "{0} timme",
            "other": "{0} timmar"
          },
          "narrow": {
            "other": "{0}h"
          },
          "perUnit": {
            "long": "{0} per timme",
            "narrow": "{0}/h",
            "short": "{0}/h"
          },
          "short": {
            "other": "{0} tim"
          }
        },
        "inch": {
          "long": {
            "other": "{0} tum"
          },
          "narrow": {
            "one": "{0} tum",
            "other": "{0}\""
          },
          "perUnit": {
            "long": "{0} per tum",
            "narrow": "{0}/tum",
            "short": "{0}/tum"
          },
          "short": {
            "other": "{0} tum"
          }
        },
        "kilobit": {
          "long": {
            "other": "{0} kilobit"
          },
          "narrow": {
            "other": "{0}kb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kb"
          }
        },
        "kilobyte": {
          "long": {
            "other": "{0} kilobyte"
          },
          "narrow": {
            "other": "{0}kB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kB"
          }
        },
        "kilogram": {
          "long": {
            "other": "{0} kilogram"
          },
          "narrow": {
            "other": "{0}kg"
          },
          "perUnit": {
            "long": "{0} per kilogram",
            "narrow": "{0}/kg",
            "short": "{0}/kg"
          },
          "short": {
            "other": "{0} kg"
          }
        },
        "kilometer": {
          "long": {
            "other": "{0} kilometer"
          },
          "narrow": {
            "other": "{0}km"
          },
          "perUnit": {
            "long": "{0} per kilometer",
            "narrow": "{0}/km",
            "short": "{0}/km"
          },
          "short": {
            "other": "{0} km"
          }
        },
        "kilometer-per-hour": {
          "long": {
            "other": "{0} kilometer per timme"
          },
          "narrow": {
            "other": "{0}km/h"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} km/h"
          }
        },
        "liter": {
          "long": {
            "other": "{0} liter"
          },
          "narrow": {
            "other": "{0}l"
          },
          "perUnit": {
            "long": "{0} per liter",
            "narrow": "{0}/l",
            "short": "{0}/l"
          },
          "short": {
            "other": "{0} l"
          }
        },
        "liter-per-kilometer": {
          "long": {
            "other": "{0} liter per kilometer"
          },
          "narrow": {
            "other": "{0}l/km"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} l/km"
          }
        },
        "megabit": {
          "long": {
            "other": "{0} megabit"
          },
          "narrow": {
            "other": "{0}Mb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Mb"
          }
        },
        "megabyte": {
          "long": {
            "other": "{0} megabyte"
          },
          "narrow": {
            "other": "{0}MB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} MB"
          }
        },
        "meter": {
          "long": {
            "other": "{0} meter"
          },
          "narrow": {
            "other": "{0}m"
          },
          "perUnit": {
            "long": "{0} per meter",
            "narrow": "{0}/m",
            "short": "{0}/m"
          },
          "short": {
            "other": "{0} m"
          }
        },
        "meter-per-second": {
          "long": {
            "other": "{0} meter per sekund"
          },
          "narrow": {
            "other": "{0}m/s"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} m/s"
          }
        },
        "mile": {
          "long": {
            "other": "{0} mile"
          },
          "narrow": {
            "other": "{0}mi"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mi"
          }
        },
        "mile-per-gallon": {
          "long": {
            "one": "{0} mile per gallon",
            "other": "{0} miles per gallon"
          },
          "narrow": {
            "other": "{0}mpg"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mpg"
          }
        },
        "mile-per-hour": {
          "long": {
            "other": "{0} mile per timme"
          },
          "narrow": {
            "other": "{0}mi/h"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mi/h"
          }
        },
        "mile-scandinavian": {
          "long": {
            "other": "{0} mil"
          },
          "narrow": {
            "other": "{0}mil"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mil"
          }
        },
        "milliliter": {
          "long": {
            "other": "{0} milliliter"
          },
          "narrow": {
            "other": "{0}ml"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ml"
          }
        },
        "millimeter": {
          "long": {
            "other": "{0} millimeter"
          },
          "narrow": {
            "other": "{0}mm"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mm"
          }
        },
        "millisecond": {
          "long": {
            "one": "{0} millisekund",
            "other": "{0} millisekunder"
          },
          "narrow": {
            "other": "{0}ms"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ms"
          }
        },
        "minute": {
          "long": {
            "one": "{0} minut",
            "other": "{0} minuter"
          },
          "narrow": {
            "other": "{0}m"
          },
          "perUnit": {
            "long": "{0} per minut",
            "narrow": "{0}/m",
            "short": "{0}/min"
          },
          "short": {
            "other": "{0} min"
          }
        },
        "month": {
          "long": {
            "one": "{0} månad",
            "other": "{0} månader"
          },
          "narrow": {
            "other": "{0}m"
          },
          "perUnit": {
            "long": "{0} per månad",
            "narrow": "{0}/mån",
            "short": "{0}/mån"
          },
          "short": {
            "other": "{0} mån"
          }
        },
        "ounce": {
          "long": {
            "other": "{0} uns"
          },
          "narrow": {
            "other": "{0}uns"
          },
          "perUnit": {
            "long": "{0} per uns",
            "narrow": "{0}/uns",
            "short": "{0}/uns"
          },
          "short": {
            "other": "{0} uns"
          }
        },
        "percent": {
          "long": {
            "other": "{0} procent"
          },
          "narrow": {
            "other": "{0}%"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} %"
          }
        },
        "petabyte": {
          "long": {
            "other": "{0} petabyte"
          },
          "narrow": {
            "other": "{0}PB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} PB"
          }
        },
        "pound": {
          "long": {
            "other": "{0} pund"
          },
          "narrow": {
            "other": "{0}lb"
          },
          "perUnit": {
            "long": "{0} per pund",
            "narrow": "{0}/pund",
            "short": "{0}/pund"
          },
          "short": {
            "other": "{0} pund"
          }
        },
        "second": {
          "long": {
            "one": "{0} sekund",
            "other": "{0} sekunder"
          },
          "narrow": {
            "other": "{0}s"
          },
          "perUnit": {
            "long": "{0} per sekund",
            "narrow": "{0}/s",
            "short": "{0}/s"
          },
          "short": {
            "other": "{0} s"
          }
        },
        "stone": {
          "long": {
            "one": "{0} engelsk sten",
            "other": "{0} engelska stenar"
          },
          "narrow": {
            "other": "{0} eng. s:n"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} eng. sten"
          }
        },
        "terabit": {
          "long": {
            "other": "{0} terabit"
          },
          "narrow": {
            "other": "{0}Tb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Tb"
          }
        },
        "terabyte": {
          "long": {
            "other": "{0} terabyte"
          },
          "narrow": {
            "other": "{0}TB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} TB"
          }
        },
        "week": {
          "long": {
            "one": "{0} vecka",
            "other": "{0} veckor"
          },
          "narrow": {
            "other": "{0}v"
          },
          "perUnit": {
            "long": "{0} per vecka",
            "narrow": "{0}/v",
            "short": "{0}/v"
          },
          "short": {
            "other": "{0} v"
          }
        },
        "yard": {
          "long": {
            "other": "{0} yard"
          },
          "narrow": {
            "one": "{0} yd",
            "other": "{0}yd"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} yd"
          }
        },
        "year": {
          "long": {
            "other": "{0} år"
          },
          "narrow": {
            "other": "{0}å"
          },
          "perUnit": {
            "long": "{0} per år",
            "narrow": "{0}/år",
            "short": "{0}/år"
          },
          "short": {
            "other": "{0} år"
          }
        }
      }
    }
  },
  "locale": "sv"
})
}